import { render, staticRenderFns } from "./ShippingZipCode.vue?vue&type=template&id=dd799522&scoped=true&"
import script from "./ShippingZipCode.vue?vue&type=script&lang=js&"
export * from "./ShippingZipCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd799522",
  null
  
)

export default component.exports